import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../../mensajes2';

import { Dimmer } from "../../spinner";
import moment, { min } from 'moment';
import { validaSoloNumero, validaMonto, formatoMonto, cmes1 } from '../../../util/varios';
import useTableScroll from '../../useTableScrollcesar';
import axios from 'axios';
import TablaDeudaContrixTransaccion from './tablaDeudaContribuyentetrans';

export const ReversarTransaccion = (props) => {

    const [mostrar2, setMostrar2] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [body, setBody] = useState(null);
    const [activate, setActivate] = useState(false);
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));
    const numCaja = JSON.parse(localStorage.getItem('numcaja'));
    const [deuda, setDeuda] = useState([]);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [formaPago, setFormaPago] = useState([]);
    const [montoPagado, setMontoPagado] = useState(0.00);
    const [idCaja, setIdCaja] = useState();
    const [desde, setDesde] = useState(0);
    const [fechaPago, setFechaPago] = useState('');
    const [numFactura, setNumFactura] = useState('');
    const [factura, setFactura] = useState();
    const [facturaDet, setFacturaDet] = useState();

    const txtNumTransa = useRef();
    const txtMotivo = useRef();
    const txtEfectivo = useRef();

    const btnCancela = useRef();
    const btnAcepta = useRef();

    const headCells = [
        { label: 'Tipo de Pago', textAlign: 'center' },
        { label: 'N° de Documento', textAlign: 'center' },
        { label: 'Nombre del Banco', textAlign: 'center' },
        { label: 'Monto', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead
    } = useTableScroll(headCells);



    const styleInput = {
        backgroundColor: '#ffff',
        color: '#444242'
    }

    const styleInputDirec = {
        backgroundColor: '#ffff',
        color: '#444242',
        height: 50,

    }

    let token = localStorage.getItem('jwtToken');
    let op = require('../../../../src/modulos/datos');

    const handleInputMontoChange = (event) => {

        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            } */
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }

            if (event.target.id === 'inputEfectivo') {
                let totfac = parseFloat(props.factura.totalfactura);
                totfac = Math.round(totfac * Math.pow(10, 2)) / Math.pow(10, 2);
                let mon = parseFloat(event.target.value.replace(/\./g, '').replace(',', '.'));
                mon = mon + parseFloat(montoPagado);
                mon = Math.round(mon * Math.pow(10, 2)) / Math.pow(10, 2);
                if (mon > totfac) {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto Efectivo mas los Otros Pagos es Mayor al Monto Total de la Factura.', icono: 'informacion' });
                    event.target.value = '0,00';
                    txtEfectivo.current.focus();
                }

            }


        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };



    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        if (desde === 1) {
            txtNumTransa.current.setAttribute("disabled", true);
            let body = ({
                idcaja: idCaja
            });
            actualizarFacturaCerrada(body);
        }
    };

    const handleCloseNo = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        if (desde === 1) {
            setDesde(0);
            txtNumTransa.current.value = '';
            setNumFactura('');
            setFechaPago('');
        }
    };


    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtNumTransa.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Número de Transacciòn no debe estar Vacio.', icono: 'informacion' });
            sigue = false;
            txtNumTransa.current.value = '';
            txtNumTransa.current.focus();

        } else if (numFactura.trim() === '') {

            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Número de factura no debe estar vacio', icono: 'informacion' });
            sigue = false;
            txtNumTransa.current.value = '';
            txtNumTransa.current.focus();

        } else if (txtMotivo.current.value === '') {

            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Incluir el Motivo del Reverso', icono: 'informacion' });
            sigue = false;
            txtMotivo.current.value = '';
            txtMotivo.current.focus();

        } else if (sigue) {
            let body = ({
                fecharev: fechaSistema,
                fechapag: fechaPago,
                nidcaja: idCaja,
                idusu: idusuario,
                espiritu: espiritu,
                motivo: txtMotivo.current.value.toUpperCase()

            });

            procesarReverso(body);
            //setMensaje({ mostrar: true, titulo: 'Confirmación.', texto: JSON.stringify(body), icono: 'confirmacion' });
        }
    }

    const cancelar = (e) => {
        e.preventDefault();
        txtNumTransa.current.setAttribute("disabled", false);
        setNumFactura('');
        setFechaPago('');
        setFormaPago([]);
        setFactura();
        setFacturaDet([]);
        setMontoPagado(0.00);
        props.onHideCancela();

    }

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        if (desde === 1) {
            setDesde(0);
            SeleccionarFactura(numFactura);
        } else if (desde === 2) {
            setDesde(0);
            txtNumTransa.current.setAttribute("disabled", false);
            setNumFactura('');
            setFechaPago('');
            setFormaPago([]);
            setFactura();
            setMontoPagado(0.00);
            props.onHideCancela();
        }
    }

    const handleCancela2 = () => {
        setMostrar2(false);
    }

    const handleAceptaPago = (datos) => {
        setMostrar2(false);
        var pago = [];
        let monpag = 0.00;
        for (let i = 0; i < formaPago.length; i++) {
            pago.push({
                fechadoc: formaPago[i].fechadoc,
                numdocumento: formaPago[i].numdocumento,
                monto: formaPago[i].monto,
                idtipopago: formaPago[i].idtipopago,
                destipopago: formaPago[i].destipopago,
                idbanco: formaPago[i].idbanco,
                nombanco: formaPago[i].nombanco,
                idcuentabancaria: formaPago[i].idcuentabancaria,
                cuentabanco: formaPago[i].cuentabanco

            });
            monpag = monpag + parseFloat(formaPago[i].monto);
        }

        pago.push({
            fechadoc: datos[0].fechadoc,
            numdocumento: datos[0].numdocumento,
            monto: datos[0].monto.replace(/\./g, '').replace(',', '.'),
            idtipopago: datos[0].idtipopago,
            destipopago: datos[0].destipopago,
            idbanco: datos[0].idbanco,
            nombanco: datos[0].nombanco,
            idcuentabancaria: datos[0].idcuentabancaria,
            cuentabanco: datos[0].cuentabanco
        });

        monpag = monpag + parseFloat(datos[0].monto.replace(/\./g, '').replace(',', '.'));
        monpag = Math.round(monpag * Math.pow(10, 2)) / Math.pow(10, 2);
        setMontoPagado(monpag);
        setFormaPago(pago);
    }

    useEffect(() => {



    }, []);

    const actualizarFacturaCerrada = (body) => {

        let endpoint = `${op.conexion}/api/Caja_Ingreso/facturacerradaactualizar`;
        setActivate(true);

        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            setActivate(false);
            if (response.status == 200) {
                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'El Cambio de Status de la Factura se Realizó Exitosamente', icono: 'exito' });
            }

        }).catch(function (error) {
            txtNumTransa.current.value = '';
            setNumFactura('');
            setFechaPago('');
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });
    }

    const procesarReverso = (body) => {

        let endpoint = `${op.conexion}/api/Caja_Ingreso/reversarfactura`;
        setActivate(true);

        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            setActivate(false);
            if (response.status == 200) {
                setDesde(2);
                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'La Transacción N°: ' + response.data.numtransa + ' fue Reversada', icono: 'exito' });
            }

        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });
    }

    const validarNumTransaccion = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarTransaccion();
            } else {
                if (event.which === 13) {
                    //txtC.current.value = '';
                }

            }
        }
    };

    const seleccionarTransaccion = () => {
        let id = txtNumTransa.current.value;
        let endpoint = `${op.conexion}/api/Caja_Ingreso/selecttransaccion?numtransaccion=${id}`;
        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {
                setIdCaja(response.data.idcaja);
                if (response.data.statusreverso === 0) {
                    //porcedes = rs.getDouble("porcedescue");
                    setNumFactura(response.data.numfactura);
                    setFechaPago(moment.utc(response.data.fechapago).format('YYYY-MM-DD'));
                    if (response.data.cerrada === 1) {
                        setActivate(false);
                        setDesde(1);
                        /*Event evt = new Event();
                        evt.keyCode = SWT.CR;
                        txtNroFactura.notifyListeners(SWT.KeyUp, evt);*/
                        let msg = 'La Factura ' + response.data.numfactura + ' pagada en fecha ' + moment.utc(response.data.fechapago).format('YYYY-MM-DD')
                            + ' se Encuentra en Status de Cerrada Desea Cambiar el Status de la Factura para poder Reversarla?.';
                        setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
                    } else {
                        //txtNumTransa.current.setAttribute("disabled", true);
                        SeleccionarFactura(response.data.numfactura);
                        /*Event evt = new Event();
                        evt.keyCode = SWT.CR;
                        txtNroFactura.notifyListeners(SWT.KeyUp, evt);*/
                    }
                } else {
                    setActivate(false);
                    setDesde(0);
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'La Transacción N°: ' + txtNumTransa.current.value + ' ya fue Reversada', icono: 'exito' });
                    txtNumTransa.current.value = '';
                }
            }
            //setActivate(false);

        }).catch(function (error) {
            txtNumTransa.current.value = '';
            setNumFactura('');
            setFechaPago('');
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })/*.finally(function () {
            setActivate(false);
        })*/;
    };

    const SeleccionarFactura = (id) => {

        setActivate(true);

        let campos = "*"
        let nomtab = "factura";
        let nomid = "numfactura";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {
                if (response.data.idfactura > 0) {
                    txtNumTransa.current.setAttribute("disabled", true);
                    setFactura(response.data);
                    seleccionarDetalleFactura(response.data);
                } else {
                    txtNumTransa.current.value = '';
                    //txtNumTransa.current.setAttribute("disabled", false);
                    setNumFactura('');
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Factura no existe.', icono: 'informacion' });
                    setActivate(false);
                }


                //if(response.data.tabladeuda !== null && response.data.tabladeuda.trim() !== '' && response.data.tabladeuda.trim() !== 'publicidad' && response.data.tabladeuda.trim() !== 'licores' && response.data.tabladeuda.trim() !== 'multa'){

                //}
            }
            //setActivate(false);
        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    };

    const seleccionarDetalleFactura = (fact) => {
        setActivate(true);
        let campos = '*';
        let nomtab = 'facturadetalle';
        let nomid = 'idfactura';
        let valor = fact.idfactura;
        let orden = 'idfacturadetalle';
        let endpoint = `${op.conexion}/api/consulta/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${valor}&orden=${orden}`;

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {
                let facdet = [];
                let nmes = "";
                for (let i = 0; i < response.data.length; i++) {
                    nmes = response.data[i].periodo.trim().length === 7 ? response.data[i].periodo.substring(0, 2) : response.data[i].periodo.substring(0, 3);
                    facdet.push({
                        idfactura: response.data[i].idfactura,
                        periodo: response.data[i].periodo,
                        anio: response.data[i].periodo.trim().length === 7 ? response.data[i].periodo.substring(3, 7) : response.data[i].periodo.substring(4, 8),
                        nummes: nmes,
                        mes: cmes1(nmes),
                        montoimpuesto: response.data[i].montoimpuesto, montointeres: response.data[i].montointeres,
                        montorecargo: response.data[i].montorecargo, montomulta: response.data[i].montomulta,
                        montoretencion: response.data[i].montoretencion,
                        montodescuento: response.data[i].montodescuento,
                        montopetro: response.data[i].montopetro,
                        tipodeuda: response.data[i].tipodeuda
                    });

                }
                setFacturaDet(facdet);
                //selectDeuda(fact, response.data);
                //setMostrar2(true);

            }
            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(function () {
            setActivate(false);
        });
    };

    const selectDeuda = (fact, facdet) => {

        setActivate(true);
        var tab = fact.tablacontribuyente.trim() === 'produccion' ? 'configproduccion' : fact.tablacontribuyente.trim() === '1x500' ? 'config1x500' : 'configminas';
        var tipod = fact.tablacontribuyente.trim() === 'produccion' ? '(tipodeuda = 2 or tipodeuda=22)' : fact.tablacontribuyente.trim() === '1x500' ? '(tipodeuda = 3 or tipodeuda=33)' : '(tipodeuda = 1 or tipodeuda=11)';

        let endpoint = `${op.conexion}/api/minas/deudas?idagente=${fact.idcontribuyente}&fecha=${fechaSistema}&tabconf=${tab}&condic=${tipod}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {


                var deu = [];
                var mul = [];
                var his = [];
                var dism = 0;
                var disd = 0;
                var totdeu = parseFloat(0.00);
                for (let i = 0; i < response.data.length; i++) {
                    for (let x = 0; x < facdet.length; x++) {
                        if (response.data[i].iddeu === facdet[x].iddeuda) {
                            deu.push({
                                anio: response.data[i].anio, mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                monto: response.data[i].mondeu, intereses: response.data[i].intmoradeu,
                                recargo: response.data[i].recargodeu, multa: response.data[i].multa,
                                retenciones: response.data[i].retencion, credito: response.data[i].acreditacion,
                                totalperi: response.data[i].subtotal, status: response.data[i].estatus,
                                idfac: response.data[i].idfact, nummes: response.data[i].nmes,
                                estatusfac: response.data[i].estatusfac, tipotransaccion: response.data[i].tipotransaccion,
                                tipodeuda: response.data[i].tipodeu, iddeu: response.data[i].iddeu,
                                tipod: response.data[i].tipod, idagente: response.data[i].idagente
                            });
                        }
                    }

                }

                setDeuda(deu);
                //setMostrar2(true);
            }
            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })


    };

    /*const seleccionarVerificacion = () => {
        setActivate(true);
        let endpoint = `${op.conexion}/api/Caja_Ingreso/selectverificacionbyid?idverificacion=${parseInt(factuPago[selectedID].numfactura.substring(1))}`;

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {

                setVerificacion(response.data);
                //SelectDeuda(factuPago[selectedID].idcontribuyente, response.data);
                setMostrar2(true);

            }
            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(function () {
            setActivate(false);
        });
    };*/

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {

                txtNumTransa.current.focus();

            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className="fw-bold text-light"><h3>Reversar Transacción.</h3></div>
                <button ref={btnCancela} className="btn bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>

                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <MensajeSiNo mensaje={mensajesino}
                    onHideNo={handleCloseNo} onHideSi={handleCloseSi} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className='titulos' style={{ height: "auto", minHeight: "auto", maxHeight: "90vh", overflow: "auto" }}>
                    <div>
                        <div className='col-sm-12 row mx-auto mb-1 px-0'>

                            <div className="input-group input-group-sm col-md-4">
                                <label className="input-group-text" id="inputGroup-sizing-sm"> Número de Transacción:</label>
                                <input type="text" ref={txtNumTransa} autoComplete='off' className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" name='fecha' onKeyUp={validarNumTransaccion} /*onBlur={validarNumTransaccion}*/ />
                            </div>

                            <div className='col-md-5'></div>
                            <div className="input-group input-group-sm col-md-3">
                                <label className="input-group-text" id="inputGroup-sizing-sm"> Fecha de Reverso:</label>
                                <label className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">  {moment.utc(fechaSistema).format('DD/MM/YYYY')}</label>

                            </div>


                        </div>
                        <fieldset className="row border-azul rounded mx-auto">
                            <legend className="float-none m-0 w-auto">Datos de la Factura</legend>
                            <div className='col-md-12 row m-0 px-0'>

                                <div className="col-md-6">
                                    <div className="input-group input-group-sm"><label className="form-label fw-bold"><i className="fas fa-receipt fa-lg px-1"></i> N° de Factura:</label> &nbsp; {numFactura}</div>
                                </div>

                                <div className="col-md-6">
                                    <div className="col-md-6 ml-auto">
                                        <div className="input-group input-group-sm"><label className="form-label fw-bold">Fecha de Pago:</label> &nbsp; {(fechaPago === '' ? fechaPago : moment.utc(fechaPago).format('DD/MM/YYYY'))}</div>
                                    </div>
                                </div>

                                <div className='m-0 px-0'><hr className='m-0 azulGradiant' /></div>

                                <div className="col-md-2">
                                    <div className="input-group input-group-sm"><label className="form-label fw-bold">Código:</label> &nbsp; {factura ? factura.idcontribuyente === '0' ? '' : factura.idcontribuyente : ''}</div>
                                </div>

                                <div className="col-md-7">
                                    <div className="input-group input-group-sm"><label className="form-label fw-bold">Nombre del Contribuyente:</label> &nbsp; {factura ? factura.nombrecontri : ''}</div>
                                </div>

                                <div className="col-md-3">
                                    <div className="col-md-10 ml-auto px-1">
                                        <div className="input-group input-group-sm"><label className="form-label fw-bold">Cédula o RIF:</label> &nbsp; {factura ? factura.cedrif : ''}</div>
                                    </div>
                                </div>

                                <div className='m-0 px-0'><hr className='m-0 azulGradiant' /></div>

                                <div className="col-md-12">
                                    <div className="input-group input-group-sm"><label className="form-label fw-bold">Concepto:</label> &nbsp; {factura ? factura.descripcion : ''}</div>
                                </div>

                            </div>

                        </fieldset>

                        <div className='col-md-12 py-1'></div>

                        <fieldset className='border-azul rounded'>
                            <legend className="float-none m-0 w-auto">Deuda del Contribuyente</legend>
                            <div className='p-0'>
                                <TablaDeudaContrixTransaccion
                                    factura={factura}
                                    deuda={facturaDet}
                                //deuda={deuda}

                                />
                            </div>
                        </fieldset>

                        <div className='col-md-12 py-1'></div>

                        <fieldset className='border-azul rounded'>
                            <legend className="float-none m-0 w-auto">Motivo del Reverso</legend>
                            <div className="input-group py-1 input-group-sm col-sm-12" >
                                <label className="input-group-text" id="inputGroup-sizing-sm"> Motivo:</label>
                                <textarea type='textarea' style={{ height: 70 }} ref={txtMotivo} autoComplete='off' className="form-control bg-light text-uppercase" />
                            </div>
                        </fieldset>



                        <div className='col-sm-12 py-1 d-flex justify-content-end  align-items-center'>
                            <button ref={btnAcepta} disabled={deshabilitado} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-success col-md-2"><i className="fas fa-check-circle">  Aceptar</i></button>
                            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill col-md-2"><i className="fas fa-window-close"> Cancelar</i></button>
                        </div>


                    </div>
                </div>



            </Modal.Body >

        </Modal >
    );
}